import {Component, OnInit} from "@angular/core";
import {New} from "../new";
import {NewService} from "../new.service";
import {Router} from "@angular/router";
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container2">
        <div class="title-clothes">
        2025/09/27 - "BUTTERFLY" 最頂級膠皮 ZYRE-03 火熱供應中🔥
        </div>

        <p class="news_content_wrap">
        <a href="https://bit.ly/3VrcQt6">🆕蝴蝶牌 BUTTERFLY 最強張力、最轉膠皮ZYRE-03</a>
        
        強者之形，煥然一新
        
        憑藉開發編號303的Ricosheet，以旋轉展現擊球品質

        -產品簡介-
       ZYRE套膠搭載了高密度短顆粒的“Ricosheet”和加厚海綿，此外還採用了擁有良好持球性和優化了耐磨性的膠皮配方，並搭配了硬度較高的 Spring Sponge X海綿。ZYRE 03採用了以旋轉展現擊球品質的開發編號303的顆粒形狀，能實現以長弧線深入對方球臺的擊球效果。推薦給在對抗相持中，想要通過強大旋轉獲取主動的選手。
          
        


        </p> 

        <div class="detailimg">
        <img src="../../../img/detail1/img1.jpg" height="500px" class="detailautoimg">
        </div>

        <p class="news_content_wrap">
        
        </p> 

        
       <button class="sharebutton" (click)="Facebook()"><img src="../../../img/fb-live-map_2.png" width="60px"></button>
       <button class="sharebutton" (click)="Google()"><img src="../../../img/photo.jpg" width="50px"></button>
       <button class="sharebutton" (click)="Twitter()"><img src="../../../img/Twitter.png" width="50px"></button>
      
       </div>
       
       
       
       <div class="new_button" style="text-align: center;margin-bottom: 30px;width:150px;margin:auto;margin-bottom:30px;">
       <button style="color: white;background-color: #CC3366;border: none;" (click)="gotoHome()">回到首頁</button></div>
    `,
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class Detail1Component implements OnInit{
  public ptitle:string;
  public pcontent:string;
  constructor(private newservice:NewService,private router:Router){}
  ngOnInit(){
    this.ptitle=this.newservice.getTitle()
    
    this.pcontent=this.newservice.getContent()
  }
  gotoHome(){
    this.router.navigate(['/']);
  }
  Facebook() {
    void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href)) ));
  }
  Google(){
    void(window.open('https://lineit.line.me/share/ui?url='.concat(encodeURIComponent(location.href)) ));
  }

  Twitter(){
    void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(location.href))));
  }


}



// WEBPACK FOOTER //
// ./src/app/news/detail/detail1.component.ts